import { Button, addToast } from '@octano/global-ui';
import { useCallback } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useHistory, useParams } from 'react-router';
import { Card, CardBody, CardSubtitle, Col, Form, Row } from 'reactstrap';
import { clean } from 'rut.js';

import { searchPostulant } from '../../api/requests/tuitionProcess';
import IdentificationTypesLoader from '../../components/IdentificationTypesLoader';
import IdentificationForm from '../../components/IdentificationForm';
import { IdentificationInputs } from '../../components/IdentificationForm/types';

const formatData = (values: IdentificationInputs) => {
  return {
    identificationTypeId: values?.identificationType?.value?.toString() || '',
    identificationValue:
      values?.identificationType?.value?.toString() === 'CL_RUT'
        ? clean(values.identificationValue)
        : values.identificationValue,
    identificationCountryId:
      values?.identificationCountry?.value?.toString() || null,
  };
};

function SearchPostulantProcessNoSua() {
  const methods = useForm<IdentificationInputs>();
  const history = useHistory();
  const { studyPlanVersionOfferPeriodAdmissionId } = useParams<{
    studyPlanVersionOfferPeriodAdmissionId: string;
  }>();

  const onSubmit = useCallback(
    async (values: IdentificationInputs) => {
      const { data, error } = await searchPostulant(formatData(values));

      if (error) {
        return addToast({
          icon: 'error',
          color: 'danger',
          text: 'Error en la consulta',
        });
      }
      if (!data?.exists) {
        return history.push(
          `/auth/registration/${studyPlanVersionOfferPeriodAdmissionId}?from=search-postulant`,
          values,
        );
      }
      addToast({
        icon: 'success',
        color: 'success',
        text: 'Ya posees una cuenta',
      });
      // Pasar el admissionId al login para crear postulación
      history.push('/auth/tuition-process', {
        ...values,
        admissionId: Number.parseInt(studyPlanVersionOfferPeriodAdmissionId),
      });
    },
    [history, studyPlanVersionOfferPeriodAdmissionId],
  );
  return (
    <Row
      className="justify-content-center align-items-center"
      style={{ minHeight: '100vh' }}
    >
      <Col xs={12} sm={10} md={6} lg={4}>
        <Card>
          <div className="text-center mt-5">
            <img
              src="/tenant/logo_expanded.svg"
              alt="tenant_logo"
              style={{ maxHeight: 50 }}
            />
          </div>

          <CardBody className=" my-4 px-5">
            <CardSubtitle className="px-5 mb-5 text-center ">
              Para crear tu cuenta debes ingresar la siguiente información:
            </CardSubtitle>
            <IdentificationTypesLoader>
              {({ data: identificationTypes }) => {
                return (
                  <div className="px-4">
                    <FormProvider {...methods}>
                      <Form onSubmit={methods.handleSubmit(onSubmit)}>
                        <Row>
                          <IdentificationForm
                            identificationTypes={identificationTypes}
                          />
                          <Col xs="12">
                            <Button type="submit" text="Continuar" fullwidth />
                          </Col>
                        </Row>
                      </Form>
                    </FormProvider>
                  </div>
                );
              }}
            </IdentificationTypesLoader>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

export default SearchPostulantProcessNoSua;
